export default class BoundingBox {
    constructor(x, y, width, height) {
        this.top = y
        this.bottom = y + height
        this.left = x
        this.right = x + width
    }
}


// WEBPACK FOOTER //
// ./src/models/boundingBox.js